import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../image/new two logo.png";
import titleImg from "../image/Final_logo_text-removebg-preview.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { name: "HOME", path: "/" },
    { name: "SERVICES", path: "/services" },
    { name: "ABOUT US", path: "/about" },
    { name: "CONTACT US", path: "/contacts" },
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <header className="w-full fixed top-0 z-50 bg-gradient-to-b from-[#0a1f44] to-[#0a2f44] shadow-md">
      <div
        className="
          relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8
          h-[64px] sm:h-[72px] md:h-[88px] lg:h-[100px]
          flex items-center
        "
      >
        {/* CENTER LOGO + TITLE */}
        <div
          className="
            absolute left-1/2 -translate-x-1/2
            top-1/2 -translate-y-1/2
            flex items-center
            gap-[1px] sm:gap-[1px] md:gap-[1px] lg:gap-[1px]
            pointer-events-none
          "
        >
          <img
    src={logo}
    alt="Logo"
    className="
     h-44 sm:h-48 md:h-52 lg:h-56
      w-auto
        translate-y-[6px] sm:translate-y-[8px]
    "
  />

  {/* <img
    src={titleImg}
    alt="Title"
    className="
      w-32 sm:w-36 md:w-44 lg:w-52 xl:w-64
      h-auto
    "
  /> */}
        </div>

        {/* DESKTOP NAVIGATION (Laptop & Desktop) */}
        <nav className="hidden lg:flex ml-auto items-center gap-6 xl:gap-10 text-sm font-inter">
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path}>
              {({ isActive }) => (
                <span
                  className={`
                    relative group cursor-pointer transition-all duration-300
                    ${
                      isActive
                        ? "text-yellow-300 glow-active"
                        : "text-blue-200 hover:text-yellow-300 hover:glow"
                    }
                  `}
                >
                  {link.name}
                  <span
                    className={`
                      absolute left-0 -bottom-1 h-[2px] bg-yellow-300
                      transition-all duration-300
                      ${isActive ? "w-full" : "w-0 group-hover:w-full"}
                    `}
                  />
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        {/* MOBILE / TABLET MENU BUTTON */}
        <button
          className="lg:hidden ml-auto text-blue-200 text-2xl p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* MOBILE / TABLET MENU */}
      {menuOpen && (
        <div className="lg:hidden bg-[#0a1f44] border-t border-blue-900">
          <nav className="flex flex-col items-center gap-6 py-8 text-base sm:text-lg font-medium">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-300 glow-active"
                    : "text-blue-100 hover:text-yellow-300 transition"
                }
              >
                {link.name}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
